const getFileNameNoExtension = (fileName) => {
    return fileName.substr(0, fileName.lastIndexOf("."));
}

export default getFileNameNoExtension